module.exports = __webpack_public_path__ + "img/blueCalen.3d468623.svg";